import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import Div100vh from 'react-div-100vh';
import { MODAL_BACKDROP_Z_INDEX } from '../ModalProvider';

export const Modal = styled.div`
  max-width: 414px;
  width: 100%;
  border-radius: 12px 12px 0 0;
  background: white;
  overflow: hidden;
  position: absolute;
  top: 80px;
  bottom: 0px;
  padding-bottom: 200px;

  ::after {
    content: ' ';
    height: 200px;
    background: white;
    width: 100%;
    display: block;
    position: fixed;
    bottom: -200px;
  }

  ${media.sm`
    border-radius: 12px;
    width: 460px;
    height: 80vh;
    bottom: 0;
    padding-bottom: 0;

    ::after {
      content: none;
    }
  `}
`;

export const ModalWrapper = styled(Div100vh)`
  display: flex;
  position: fixed;
  width: 100vw;
  z-index: ${MODAL_BACKDROP_Z_INDEX};
  background: #00000040;
  align-items: flex-end;
  justify-content: center;
  top: 0;
  left: 0;
  bottom: 0;

  ${media.sm`
    align-items: center;
  `}
`;
